import styles from "./Highlight.module.css";
import { ChevronIcon } from "shared/components/Icons";
import { createInternalHref } from "../utils/createInternalHref";
import { useRouter } from "next/router";

export const Highlight = ({ href, title, text, thumbnail }) => {
  if (!title || !text || !thumbnail.url) return <></>;
  const { locale } = useRouter();

  href =
    href.url ||
    createInternalHref({
      href: href.ref.slug.current,
      type: href.ref._type,
      locale,
    });

  return (
    <a className={styles.container} href={href}>
      <img
        className={styles.thumbnail}
        src={thumbnail.url}
        alt={thumbnail.alt}
      ></img>
      <div className={styles.title}>{title}</div>
      <p className={styles.text}>{text}</p>
      <ChevronIcon />
    </a>
  );
};
